<template>
  <div>    
    <div class="row">
      <div class="col"> 
        <h1>Order Payment - Success</h1>

          <div class="text-center py-5" v-if="isLoading">
              <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" ></b-spinner>
          </div>
        

          <b-alert variant="danger" :show="hasError && !isLoading">{{errorMessage}}</b-alert>

           <b-alert variant="success" :show="!hasError && !isLoading" class="my-5">Payment received for order {{ orderNumber }}. Thank you. <i class="lni lni-checkmark-circle" style="font-size:36px;"></i></b-alert>

           <p v-if="!isLoading">
             You may close this page. There is no further action required.
           </p>

           <p v-if="!isLoading">
             Have a great day.
           </p>


      </div>
    </div>
  </div>
</template>

<script>

import frontendRepo from '@/api/repos/frontendRepo'


export default {
  mounted() {
    this.updateOrder()
  },

   data() {
    return {
      hasError:false,
      errorMessage:"",
      isLoading:true,
      orderNumber:''
    };
  },

  methods: {
   async updateOrder(){
     this.isLoading=true
     try{
       let {data} = await frontendRepo.paidSuccess(this.$route.params.uid)
       this.orderNumber =data.order
     }catch($e){
       this.hasError=true
      this.errorMessage = "Something went wrong."

     }finally{
       this.isLoading=false
       console.log(this.isLoading)
     }
   }
  },

 
};
</script>

<style>
</style>